export const API_URL = "https://pageback.sku-sku.com";
